module.exports = __webpack_public_path__ + "static/media/close.1feec159.svg";